/**
 * Error thrown when a shop was successfully created but could not be fetched within the polling timeout.
 */
export class ShopCreatedButNotFetchedError extends Error {
  constructor() {
    super('Failed to fetch the newly created shop after multiple retries');
    this.name = 'ShopCreatedButNotFetchedError';
  }
}

